import { render, staticRenderFns } from "./throbaxScreenshots.vue?vue&type=template&id=6ec309bd&"
import script from "./throbaxScreenshots.vue?vue&type=script&lang=js&"
export * from "./throbaxScreenshots.vue?vue&type=script&lang=js&"
import style0 from "./throbaxScreenshots.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports